import React, { Component } from 'react';
import * as Constants from '../../../../utilities/constants/Constants';
import { ProductCard } from '../ProductCard/ProductCard';
import { string } from '../../../../localization';
import './CompleteProductList.scss';
import { Container, Col, Row } from 'reactstrap';
import MediaQuery from 'react-responsive';

class CompleteProductList extends Component {
  handleGoBack = () => {
    const { pageController } = this.props;
    pageController(Constants.PRODUCT_GROUP_PAGE);
  };

  render() {
    const {
      items,
      setSelectedProduct,
      isTurkeyLaptop,
      error,
      isSingleFamilyModels
    } = this.props;

    let medColumns = '3 ';
    let largeColumns = '3 ';
    if (items.length <= 3) {
      medColumns = '4 ';
      largeColumns = '4 ';
    }
    if (items.length <= 2) {
      medColumns = '6 ';
      largeColumns = '6 ';
    }

    return (
      <div className='complete-product-list'>
        {items && items.length > 0 ? (
          <>
            <Container>
              {!isSingleFamilyModels() ? (
                <MediaQuery query='(min-width: 766px)'>
                  <span className='title'>
                    <span className='group-name'>{items[0].laptopFamily}</span>
                    <div
                      role='button'
                      tabIndex='0'
                      className='helper-text'
                      onClick={() => this.handleGoBack()}
                      onKeyPress={() => {}}
                    >
                      {' '}
                      {string.Go_BACK_KEY}
                    </div>
                  </span>
                </MediaQuery>
              ) : null}
              <Row>
                {items.map(item => (
                  <Col
                    xs='6'
                    sm={medColumns}
                    md={medColumns}
                    lg={largeColumns}
                    xl={largeColumns}
                  >
                    <ProductCard
                      item={item}
                      clickHandler={setSelectedProduct}
                      isWhiteBackground={isTurkeyLaptop}
                    />
                  </Col>
                ))}
              </Row>
            </Container>
          </>
        ) : (
          error()
        )}
      </div>
    );
  }
}

export default CompleteProductList;
